import React from "react";
import Login from './Login'
import { ROUTING_APP_1, ROUTING_TAB_1 } from '../../constants/routing'
import { NAME_APP1 } from '../../constants/wording'

function LoginApp1() {
  return (
    <Login name={NAME_APP1} routing={ROUTING_APP_1} routingTab={ROUTING_TAB_1} login="jane.doe@ima.fr" password="******" />
  )
}

export default LoginApp1